// extracted by mini-css-extract-plugin
export var icon = "_65-1";
export var subtext = "_65-0";